module.exports = __webpack_public_path__ + "static/media/logoPTT.c24482ed.png";